// cspell:disable
import { idFormat, type ID } from "@redotech/redo-ids-cockroach";

export type AccountId = ID<"account">;
export const accountIdFormat = idFormat<AccountId>({ prefix: "acc_" });
